import ContestListItem from "./ContestListItem";
import EmptyState from "../shared/EmptyState";
import React from "react";
import { ApplicationWithId } from "../../interfaces/IApplications";
import {
  Box,
  Divider,
  List,
  Typography
  } from "@mui/material";
import { ContestWithId } from "../../interfaces/IContests";
import { EmojiEvents } from "@mui/icons-material";

// Komponent dla pustego stanu listy
interface EmptyContestsListProps {
  message: string;
}

function EmptyContestsList({ message }: EmptyContestsListProps) {
  return (
    <Box
      sx={{
        border: "1px dashed #ccc",
        borderRadius: 1,
        p: 2,
      }}
    >
      <EmptyState message={message} />
    </Box>
  );
}

// Komponent dla nagłówka listy
interface ContestsListHeaderProps {
  title: string;
}

function ContestsListHeader({ title }: ContestsListHeaderProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, px: { xs: 2, sm: 3 } }}>
      {/* <EmojiEvents sx={{ color: "#6366f1", fontSize: 20 }} /> */}
      <Typography variant="h4" sx={{ fontWeight: 600, color: "#2f2f2f" }}>
        {title}
      </Typography>
    </Box>
  );
}

// Komponent dla listy zawodów
interface ContestsListContentProps {
  contests: ContestWithId[];
  applications: ApplicationWithId[];
  onAddApplication: (contest: ContestWithId) => void;
  onEditApplication: (contestId: string, applicationId: string) => void;
  onRemoveApplication: (applicationId: string) => void;
}

function ContestsListContent({
  contests,
  applications,
  onAddApplication,
  onEditApplication,
  onRemoveApplication,
}: ContestsListContentProps) {
  const getApplicationForContest = (contestId: string) => {
    return applications.find((app) => app.contestId === contestId);
  };

  return (
    <List
      sx={{
        bgcolor: "background.paper",
        borderRadius: 0,
        border: "none",
        mx: 0,
        px: 0,
      }}
    >
      {contests.map((contest, index) => {
        const application = getApplicationForContest(contest.id!);

        return (
          <React.Fragment key={contest.id}>
            <ContestListItem
              contest={contest}
              application={application}
              onAddApplication={onAddApplication}
              onEditApplication={onEditApplication}
              onRemoveApplication={onRemoveApplication}
            />
            {index < contests.length - 1 && <Divider />}
          </React.Fragment>
        );
      })}
    </List>
  );
}

// Główny komponent ContestsList
interface ContestsListProps {
  contests: ContestWithId[];
  applications: ApplicationWithId[];
  title: string;
  emptyMessage: string;
  onAddApplication: (contest: ContestWithId) => void;
  onEditApplication: (contestId: string, applicationId: string) => void;
  onRemoveApplication: (applicationId: string) => void;
}

export default function ContestsList({
  contests,
  applications,
  title,
  emptyMessage,
  onAddApplication,
  onEditApplication,
  onRemoveApplication,
}: ContestsListProps) {
  if (contests.length === 0) {
    return <EmptyContestsList message={emptyMessage} />;
  }

  return (
    <Box>
      <ContestsListHeader title={title} />
      <ContestsListContent
        contests={contests}
        applications={applications}
        onAddApplication={onAddApplication}
        onEditApplication={onEditApplication}
        onRemoveApplication={onRemoveApplication}
      />
    </Box>
  );
}
